<template>
    
    <div style="background-color: white;">
        <div >
        <h1 class="page-title letraDelTitulo enMayusculas col-12">{{nombreConvocatoria}}</h1>
            <div class="container caja-principal" >
    <section class="contenedorBusqueda">
        <h4>Busqueda del Aspirante</h4>
        <section>
        <h6>Folio del Aspirante</h6>
        <input type="text" v-model="SeleccionAspiranteEdicion.Folio" :class="'form-control campo'"/>
        </section>
        <section>
        <h6 style="padding: 5px">Convocatoria</h6>   
                        <CSelectGenerico class="campo" 
                        v-on:valorParaElPadre="cambioConvocatoria"  
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="'Convocatorias1'" 
                        :valorDefinido="-1" 
                        :elementos="opciones" 
                        :mansajeValorDefinidoSingular="'Convocatoria'">
                       </CSelectGenerico>
        </section>
        <button class="btn boton-pestana btn-info" @click="BuscarAspirante">Buscar Datos </button>
    </section>
                  
    <div class="caja-contenedora-formulario">
        <div>
                      
        </div>
           
        <div class="pestanas">
            <button class="btn boton-pestana" :class="(mostrarInformacion)?'btn-success':'btn-secondary' " @click="mostrarInformacion=true">Información </button>
            <button class="btn boton-pestana" :class="(mostrarInformacion)?'btn-secondary':'btn-success' " @click="mostrarInformacion=false" v-if="CamposParaCrearFormulario.find(c => c.IdTipoCampo==6)!= undefined">Documentos </button>
        </div>
        <!--<div class="pestanas">
            <h4 style="color: rgb(228, 3, 3)">En caso de dudas o aclaraciones, podrá comunicarse al teléfono 449-979-20-96 en un horario de  08:30 a 15:30 horas.</h4>
        </div>-->
        <div v-show="mostrarInformacion">
           
          
            <!-- IdDeConvocatoria: 0,
            IdCategoria: 0,
            Estatus: "", -->
            <div class="caja-formulario" v-if="DatosDelAsistente.Estatus!=''">
            <h6>Estatus del Aspirante</h6>
            <span class="estadoGrid" :class="(DatosDelAsistente.Estatus=='Registrado')?'registradoGrid':(DatosDelAsistente.Estatus=='Aprobado')?'acceptadoGrid':'rechazadoGrid'">{{DatosDelAsistente.Estatus}}</span>
            <!-- <span class="estadoGrid acceptadoGrid">Aprobado</span>
            <span class="estadoGrid rechazadoGrid">Rechazado</span>              -->
           </div>

            <div class="caja-formulario" >
                      <h6>Folio del Aspirante<label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="DatosDelAsistente.Folio" :class="'form-control campo'"/>
           </div>  
            <div class="caja-formulario" >
                      <h6>CURP del Aspirante<label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="DatosDelAsistente.Curp" :class="'form-control campo'"  placeholder="Ingrese clave única de registro de población"  maxlength="18" @keyup="llenarFormulario()"/>
           </div>  
           
        <div class="caja-formulario" >
                      <h6>Nombre del Aspirante<label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="DatosDelAsistente.NombreAspirante" :class="'form-control campo'"  placeholder="Ingrese el nombre del aspirante"  @keyup="llenarFormulario()"/>
           </div>  

           <div>        
            <div class="caja-formulario" >
                      <h6>Correo Aspirante <label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="DatosDelAsistente.CorreoAspirante" class="form-control campo" :class="claseCssParaEmail" onpaste="return false" autocomplete="off"  placeholder="Ingrese correo electrónico" @keyup="llenarFormulario()" />
        </div>
        <!-- <div class="caja-formulario">
                      <h6>Confirma Correo Aspirante <label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="correoAspiranteValidado" class='form-control campo date' :class="claseCssParaEmail" onpaste="return false" autocomplete="off" placeholder="confirme su correo electrónico" @keyup="llenarFormulario()" />
        </div> -->
        </div>

        <div v-for="(campo,index) in CamposParaCrearFormulario" :key="index">
                <div class="caja-formulario" v-if="campo.IdTipoCampo==1">
                      <h6>{{campo.Nombrecampo}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text"  :id="campo.FormularioIdentificador" :class="'form-control campo'" placeholder="Ingrese Información" @keyup="llenarFormulario()"/>
        </div>

        <div class="caja-formulario" v-if="campo.IdTipoCampo==2">
            <h6>{{campo.Nombrecampo}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
            <input type="date" :id="campo.FormularioIdentificador" :value="campo.valor" :language="es" :class="'form-control campo'" format="dd-MM-yyyy"/>
          </div>  
                
         <div class="caja-formulario" v-if="campo.IdTipoCampo==7">
                      <h6>{{campo.Nombrecampo}}<label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="campo.FormularioIdentificador" :class="'form-control campo'"  placeholder="Ingrese clave única de registro de población" @keyup="llenarFormulario()" maxlength="18"/>
        </div>

        <div class="caja-formulario" v-if="campo.IdTipoCampo==4">
                    <h6>{{campo.Nombrecampo}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="tel" :id="campo.FormularioIdentificador" :class="'form-control campo'" maxlength="18" placeholder="Ingrese número telefónico" @keyup="llenarFormulario()" @keypress="formateoTelefono(campo.FormularioIdentificador)" @blur="formateoTelefono(campo.FormularioIdentificador)"/>
        </div>
        <div v-if="campo.IdTipoCampo==5">        
            <div class="caja-formulario" >
                      <h6>{{campo.Nombrecampo}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="campo.FormularioIdentificador" class="form-control campo" :class="claseCssParaEmail" onpaste="return false" autocomplete="off"  placeholder="Ingrese correo electrónico" @keyup="validarCorreosElectronicos " />
        </div>
        <div class="caja-formulario">
                      <h6>Confirma {{campo.Nombrecampo}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="campo.FormularioIdentificador+'confirma'" class='form-control campo date' :class="claseCssParaEmail" onpaste="return false" autocomplete="off" placeholder="confirme su correo electrónico" @keyup="validarCorreosElectronicos" />
        </div>
        </div>
        <div class="caja-formulario" v-if="campo.IdTipoCampo==3">
                      <h6>{{campo.Nombrecampo}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <select :id="campo.FormularioIdentificador" :class="'form-control select-estilos'" @change="llenarFormulario()">
                    <option selected value="">Seleccione una Opcion</option>
                    <option v-for="(opcion,i) in campo.selects" :value="opcion.index" :key="i">{{opcion.opcion}}</option>
                    <!-- <option value="2">Casado</option> -->
                    </select>
        </div>
        <div class="caja-formulario" v-if="campo.IdTipoCampo==8">
            <h6>{{campo.Nombrecampo}}<label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
            <textarea type="text" :id="campo.FormularioIdentificador" :class="'form-control campo'" placeholder="Ingrese texto" @keyup="llenarFormulario()"></textarea>        
        </div>

        <div class="caja-formulario" v-if="campo.IdTipoCampo==9">
            <h6>{{campo.Nombrecampo}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>            
            <input type="datetime-local" :id="campo.FormularioIdentificador" :value="campo.valor" :class="'form-control campo'" :min="new Date().toISOString().slice(0,19)">  
        </div> 
    </div>   
    </div>
<div v-show="mostrarInformacion==false">

<div class="pestanas">
            <h4 style="color: rgb(228, 3, 3)">Solo se aceptarán documentos en formato PDF.</h4>
</div>

<div v-for="(campo,index) in CamposParaCrearFormulario" :key="index">
    <div class="caja-formulario" v-if="campo.IdTipoCampo==6">
            <h6>{{campo.Nombrecampo}}: <label v-if="campo.Requerido"  class="asterisco-requerido">(*)</label></h6>
            <input type="file" :id="campo.FormularioIdentificador" :class="'form-control select-estilos'" accept="application/pdf" @change="cargarDocumento($event,campo.FormularioIdentificador)" />
    </div>
</div>

</div>
    </div>
    <div class="botones-guardar">
        <button class="btn btn-danger boton-general"  v-if="mostrarBtnGuardar" @click="guardarInformacionAspirante()">GUARDAR</button>
        <button class="btn btn-success boton-general" v-if="!mostrarBtnGuardar"  @click="mostrarInformacion=!mostrarInformacion">CONTINUAR LLENADO</button>
     
    </div>
</div>
         <!-- MODAL CON VISUALIZADOR DE REPORTE -->
    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-documento">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Reporte generado</h5>
                        <button id="btn-cerrar-visualizador-reporte-notificador-asignaciones" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <PDFDocument 
                            :url="documento.url" 
                            :ArchivoAConvertir=null
                            :EsBase64="EsBase64"
                            :EsBlob = "EsBlob"
                            :height="documento.height"
                            :key="'VACANOT' + documento.contRender" />
                    </div>
                    <button class="btn btn-success" @click="aceptarDocumento">Aceptar</button>           
                </div>
            </div>
        </div>
    </div>

    <div v-if="!convocatoriaEncontrada" class="convocatoria-noencontrada">
        <img class="imagen-nofound" src="https://themisfsweb.poderjudicialags.gob.mx/SICPO/ImagenesPortal/alert.png" alt="Convocatoria no encontrada"><br>
    <label>
        Lo sentimos, la convocatoria no existe o ya ha caducado 
    </label>
    </div>
</div>

</template>

<script>
import axios from "axios"
import api from '@/../static/js/api'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import comun from "@/../static/js/comun"
import enumeraciones from '@/../static/js/enumeraciones'


export default {
   
    props:{
        seccionDeLaPaginaWeb:Object
    },
    components:{
        Datepicker,
        PDFDocument,
        CSelectGenerico
    },
    data() {
        return{
        es: es,
        enumeraciones,
        opciones:[{valor:1,nombre:"Valor Uno"}],
        filtro:{
                convocatoria:0,
                estado:0
            },
        DatosDelAsistente:{
            Curp:"",
            NombreAspirante: "",
            CorreoAspirante: "",
            IdDeConvocatoria: 0,
            IdCategoria: 0,
            Estatus: "",
            Folio: 0,
            FormularioDeaspirante:[]

        },
        SeleccionAspiranteEdicion:{
            Folio:0,
            Convocatoria:0
        },
        documento:{
            url:"",
            archivoDeReporte:"",
            height: '750px',
            contRender:1
        },
        EsBase64:false,
        EsBlob : {
            esBlob:true,
            blob:null
        },
        //IdFormulario:0,
        convocatoriaEncontrada:false,
        nombreConvocatoria:null,
        identificadorConvocatoria:0,
        fechaActual:new Date(),
        CamposParaCrearFormulario:[],
        CamposParaAltaFormulario:[],
        mostrarInformacion:true,
        mostrarBtnGuardar:false,
        correoValidado:false,
        claseCssParaEmail:'',
        fechaFormulario:new Date(),
        fechaHora:new Date(),
        FormatoFechaHora : 'YYYY-MM-DD HH:MM:SS',
        nombreAspirante:'',
        correoAspirante:'',
        correoAspiranteValidado:''
        }
    },       
    methods:{

        cambioConvocatoria:async function(parametro,parametroDos){
            await Promise.resolve( this.SeleccionAspiranteEdicion.Convocatoria = parametro.target.value); 
        },
        BuscarAspirante:async function(){
            console.log("Buscar Aspirante::::",this.SeleccionAspiranteEdicion)
            const METODO_API_TRAER_ASPIRANTE = api.conexion + api.convocatorias.sistema.EdicionInformacionDeAspirante+this.SeleccionAspiranteEdicion.Folio+"&IdentificadorDeConvocatoria="+this.SeleccionAspiranteEdicion.Convocatoria;
            axios.get(METODO_API_TRAER_ASPIRANTE).then(respuesta => {
                console.log("RESPUESTA ",respuesta)    
                comun.SeEstaCargandoInformacion(false);
                   
                    if (respuesta.data.SiHayError) {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                        this.DatosDelAsistente = respuesta.data.DatosDeAsistente;                   
                    }
                }).catch(excepcion => {
                    console.log("error",excepcion);
                    comun.SeEstaCargandoInformacion(false);                   
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                });

        },
        obtenerConvocatorias: async function(){
            const METODO_API_CONVOCATORIAS = api.convocatorias.sistema.ObtenerTitulosConvocatorias;
            axios.get(api.conexion + METODO_API_CONVOCATORIAS).then(respuesta => {
                console.log("RESPUESTA ",respuesta)    
                comun.SeEstaCargandoInformacion(false);
                   
                    if (respuesta.data.SiHayError) {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                        this.opciones = respuesta.data.titulos                   
                    }
                }).catch(excepcion => {
                    console.log("error",excepcion);
                    comun.SeEstaCargandoInformacion(false);                   
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                });

        },

        llenarFormulario:async function(){
            //console.log("v-modelo::::",$(this.curpObligatoria).val());
         
            console.log("llenarFormulario CamposParaAltaFormulario before::",this.CamposParaCrearFormulario)
            this.CamposParaCrearFormulario.map(e=>{
                let contenido = e;
               // let valor = $('#'+contenido.FormularioIdentificador).val()
               // if(contenido.Requerido){
                    if(contenido.tipo != 6){
                        contenido.valor = $('#'+contenido.FormularioIdentificador).val();        
                    }

                  //  else contenido.valor = null;
                //}
            });

            console.log("Llenar Formulario Campos Para Alta Formulario ::",this.CamposParaCrearFormulario);
            this.validarFormularioRequerido();
        },
       validarFormularioRequerido:function(){ 
    
            let camposRequeridosLLenos = true;
            //console.log("validarFormularioRequerido before validar curp:::", this.curpObligatoria);
            //console.log("validarFormularioRequerido CamposParaAltaFormulario before::",this.CamposParaCrearFormulario);
            //camposRequeridosLLenos = this.validarCurp(this.curpObligatoria);
            
    if(this.validarCurp(this.curpObligatoria) && (this.nombreAspirante != null && this.nombreAspirante !="") && (this.validarCorreoObligatorio())){
        console.log("curp validada:::", this.curpObligatoria);
    this.CamposParaCrearFormulario.map(e=>{
    let contenido = e
        if(contenido.EsRequerido){
            //console.log("entra::::")            
            if(contenido.IdTipoCampo==5  ){
                if(!this.correoValidado && (contenido.valor=="" || contenido.valor==null) ){
                camposRequeridosLLenos = false;
                //console.log("entra al if type 5:::",contenido.valor)
            } }else if(contenido.IdTipoCampo==7 ){
                if((contenido.valor=="" || contenido.valor==null) && !this.validarCurp(contenido.valor)){
                camposRequeridosLLenos = false;
               // console.log("entra al if type 7:::",contenido.valor)
            }                
            }else {
                if(contenido.valor=="" || contenido.valor==null){
                //console.log("FormularioIdentificador:::",contenido.FormularioIdentificador);
                //console.log("Valor:::",contenido.valor);
                camposRequeridosLLenos = false;           
            }else{camposRequeridosLLenos = true;}
            }            
           }                
           });
           }else{camposRequeridosLLenos = false;}
           //console.log("validarFormularioRequerido CamposParaAltaFormulario final::",this.CamposParaCrearFormulario);
           console.log("validando::",camposRequeridosLLenos)
           this.mostrarBtnGuardar = camposRequeridosLLenos;
          },

        guardarInformacionAspirante:async function(){debugger
 
            //console.log("::: inicio guardarInformacionAspirante:::");
            let dialog = bootbox.dialog({
                                message: '<div style="text-align:center"><i class="fas fa-spinner fa-spin" style="color:#09BCEC;font-size:3em"></i><br> <p style="font-size:2em" class="text-center mb-0"> Por favor espere mientras procesamos la información.</p></div>',
                                closeButton: false
                                });

            const SERVIDOR = api.conexion;             
            const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.convocatoriasWeb.NuevoAspirante;
            const END_POINT = SERVIDOR+METODO_API_AGREGAR;
             return axios.post(END_POINT, this.crearPeticion()).then(async response => {debugger
                console.log("respuesta:::",response);
                dialog.modal('hide');
                if(response.data.SiHayError){
                    dialog.modal('hide');
                    bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Cerrar",
                                className: 'btn-danger',
                            }
                        }
                    });
                               
                }else{
                
                   // dialog.modal('hide');
                  
                    bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-check-circle" style="color: #07cf9d;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Felicidades!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Su registro ha sido exitoso, el folio de su solicitud es '+response.data.folioDeRegistro+' además se le ha enviado un correo de confirmación a la dirección especificada.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                                }
                        }
                    });
                    this.limpiarFormulario();
                    
                }
             }).catch(e => {
                dialog.modal('hide');
                bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Cerrar",
                                className: 'btn-danger',
                            }
                        }
                    });
                console.log("A sucedido un error en el sistema::",e.message);
             });
        
        },
        crearPeticion:function(){
            var bodyFormData = new FormData();
            console.log("Crear Peticion Campos Para Alta Formulario ::",this.CamposParaCrearFormulario);
            this.CamposParaCrearFormulario.map(cont=>{
                let contenido = cont          
                    if(contenido.IdTipoCampo == 6 && contenido.valor!="" && contenido.valor!=null){
                        
                        console.log("crearPeticion validation document form data::",contenido.valor); 
                        //console.log("crearPeticion validation document form data file::",contenido.valor.File);                                
                        bodyFormData.append(contenido.FormularioIdentificador,contenido.valor);
                        //let valor = contenido.valor.File.name.replace(".pdf","");
                        contenido.valor = contenido.valorNombre;

                        console.log("crearPeticion validation document form data final::",contenido.valor); 
                    }
            });
            
            //console.log("crearPeticion CamposParaAltaFormulario finall json::", JSON.stringify(this.CamposParaCrearFormulario));
            bodyFormData.append('CurpAspirante',this.curpObligatoria.toUpperCase());
            bodyFormData.append('NombreDelAspirante',this.nombreAspirante);
            bodyFormData.append('CorreoAspirante',this.correoAspirante);
            this.filterForm();
            console.log("crearPeticion CamposParaAltaFormulario finall::",this.CamposParaAltaFormulario);
            bodyFormData.append('FormularioRegistradoPorAspirante',JSON.stringify(this.CamposParaAltaFormulario));
            bodyFormData.append('NombreConvocatoria',this.nombreConvocatoria);
            bodyFormData.append('ConvocatoriaIdentificador',this.identificadorConvocatoria);
            //bodyFormData.append('EsPrueba',false);
            //console.log("crearPeticion bodyFormData:: ", bodyFormData);
            //console.log("crearPeticion curp Data:: ", this.curpObligatoria);
            //console.log("crearPeticion curp Data json:: ", JSON.stringify(this.curpObligatoria));
            return bodyFormData;
        },
        cargarDocumento:function(e, FormularioIdentificador){
                //console.log("cargarDocumento DOCUMENTO::",e.target.files[0])
                //console.log("FormularioIdentificador::::",FormularioIdentificador)

                this.CamposParaCrearFormulario.map(cont=>{
                let contenido = cont;              
                    console.log("contenido::", contenido);
                 
                    if(contenido.IdTipoCampo == 6 && contenido.FormularioIdentificador == FormularioIdentificador){
                        contenido.valor = e.target.files[0];
                        contenido.valorNombre = e.target.files[0].name.replace(".pdf","");
                        console.log('cargarDocumento valor:: ',contenido);
                        console.log('cargarDocumento nombre archivo:: ',contenido.valorNombre);
                        console.log('cargarDocumento File:: ', e.target.files[0]);
                        if(contenido.valor!=undefined && contenido.valor != null){ 
                        console.log('send convierteDocumentoABlob');
                        this.convierteDocumentoABlob(e.target.files[0]);                       
                    }    
                    }
                
            });

            console.log("jsonLLenoDocumentos::",this.CamposParaCrearFormulario)
            this.validarFormularioRequerido();
             
        },
        convierteDocumentoABlob:function(documento){
            documento.arrayBuffer().then((arrayBuffer) => {
            const blob = new Blob([new Uint8Array(arrayBuffer)], {type: documento.type });
            this.EsBlob.blob = blob;
            this.documento.contRender++;
            $('#visualizador-documento').modal('show'); 
            console.log('blob',blob);
            });

        },
        aceptarDocumento:function(){
            $('#visualizador-documento').modal('hide'); 
        },
       validarCorreoObligatorio:function(){
           let flag = false;           
            if(this.correoAspirante!=null && this.correoAspiranteValidado!=null && this.correoAspirante !="" && this.correoAspiranteValidado!="" ){     
                if(this.correoAspirante.toLowerCase() == this.correoAspiranteValidado.toLowerCase() && this.correoAspirante.includes('@') && this.correoAspiranteValidado.includes('@')){
                    this.claseCssParaEmail = 'correo-valido';
                    flag=true;
                    console.log("validarCorreoObligatorio::correo-valido:: ",flag);
                }else{
                    this.claseCssParaEmail = 'correo-invalido';
                    console.log("validarCorreoObligatorio::correo-valido:: ",flag);
                }
             } 
           console.log("validarCorreoObligatorio::",flag);
         return flag;
              
        },
        validarCorreosElectronicos:function(){
           //console.log("::start validarCorreosElectronicos::");
           //console.log("::validarCorreosElectronicos this.CamposParaCrearFormulario before::",this.CamposParaCrearFormulario);
           this.correoValidado = false
           this.CamposParaCrearFormulario.filter(s => s.IdTipoCampo==5).map(cont => {
           //console.log("::validarCorreosElectronicos mails::",cont);
            let correo = $('#'+cont.FormularioIdentificador).val();
            let correoConfirma = $('#'+cont.FormularioIdentificador+'confirma').val();
           //console.log("entravalidacionde correos",correo);
           //console.log("entravalidacionde correoConfirma",correoConfirma);
            if(correo!=null && correoConfirma!=null && correo !="" && correoConfirma!="" ){                
                if(correo.toLowerCase() == correoConfirma.toLowerCase() && correo.includes('@') && correoConfirma.includes('@')){
                    this.claseCssParaEmail = 'correo-valido';
                    this.correoValidado=true;
                    console.log('correo-valido');
                }else{
                    this.claseCssParaEmail = 'correo-invalido';
                    console.log('correo-invalido');
                }
             } 

           });
           //console.log("::validarCorreosElectronicos this.CamposParaCrearFormulario finall::",this.CamposParaCrearFormulario);
           this.llenarFormulario();
              
        },

        limpiarFormulario:function(){         
            this.fechaFormulario=new Date();
            this.fechaHora=new Date();
            this.mostrarBtnGuardar=false;
            this.claseCssParaEmail='';
            this.correoValidado=false;
            this.curpObligatoria='';
            this.nombreAspirante='';
            this.correoAspirante='';
            this.correoAspiranteValidado='';
            this.CamposParaAltaFormulario=[];
            //console.log("limpiarFormulario this.CamposParaCrearFormulario:: ", this.CamposParaCrearFormulario);
            this.CamposParaCrearFormulario.map(cont => {
                if(cont.IdTipoCampo==2) $('#'+cont.FormularioIdentificador).val(new Date());
                else{
                    $('#'+cont.FormularioIdentificador).val("");
                }

                if(cont.IdTipoCampo==9) $('#'+cont.FormularioIdentificador).val(new Date());
                else{
                    $('#'+cont.FormularioIdentificador).val("");
                }

                if(cont.IdTipoCampo==5) $('#'+cont.FormularioIdentificador+'confirma').val("");
            })

        },

        CrearFormulario:function(){
         //   3&IdentificadorDeConvocatoria=1

        //  const METODO_API_EDICION = api.conexion+api.convocatorias.sistema.EdicionInformacionDeAspirante+this.SeleccionAspiranteEdicion.Folio+"&IdentificadorDeConvocatoria="+this.SeleccionAspiranteEdicion.Convocatoria;
        //     console.log("METODO_API_AGREGAR:::",METODO_API_EDICION)
        //     axios.get(METODO_API_EDICION,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(respuesta => {
        //             comun.SeEstaCargandoInformacion(false);
        //             if (respuesta.data.SiHayError) {
        //                 console.log(respuesta); 
        //                 comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
        //             } 
        //             else {
                    
        //               console.log("RESPUESTA ",respuesta.data)
        //             this.DatosDelAsistente = respuesta.data.DatosDeAsistente;                  
        //               //  comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
        //             }
        //         }).catch(excepcion => {
        //             comun.SeEstaCargandoInformacion(false);
        //             console.log(excepcion);
        //             comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
        //         });
        },
        formateoTelefono:function(elemento){
            //console.log("inputId:::",elemento);
            let telefono = $('#'+elemento).val();
            if (telefono != "")
            { 
                var numeros = telefono.replace(/\D/g, ''),
                char = {0:'(',3:') ',6:'-'};
                telefono = '';
                    let upto = numeros.length; 
                    if(numeros.length < 10) 
                    { 
                        upto = numeros.length; 
                    }
                    else
                    { 
                        upto = 10; 
                    }
                    for (var i = 0; i < upto; i++) {
                        telefono += (char[i]||'') + numeros[i];
                    }
            }
            
           // console.log("formato telefono::",telefono)
            $('#'+elemento).val(telefono);

        },
        validarCurp: function(curp){
            let campoValido = true;
        if(curp == undefined || curp == null || curp == "" || curp.toString().trim() == "" || curp.length < 18) { 
            //console.log("validarcurp curp lengt:: ",curp.length);
            //console.log("validarcurp :: ",curp);
            //console.log("validarcurp valido ? validation:: ",campoValido);
            campoValido = false;
        }
        console.log("validar curp valido ?:: ",campoValido)
        return campoValido;
        },
     
        filterForm:function(){
            this.CamposParaAltaFormulario = this.CamposParaCrearFormulario.filter(function (campo){
                console.log("filterForm campo",campo);
                return campo.valor!=null && campo.valor!="";
            });
           // console.log("filterForm this.CamposParaAltaFormulario", this.CamposParaAltaFormulario);
           // console.log("filterForm this.CamposParaCrearFormulario", this.CamposParaCrearFormulario);
        }
      


    },
    mounted(){
       
        this.CrearFormulario();
        this.obtenerConvocatorias();

    }

}
</script>
<style scoped>
.contenedorBusqueda {
    padding: 1em;
    text-align: center;
    margin: 2em;
    border-radius: 25px;
    box-shadow: 0px 0px 30px rgb(188 188 189);
}
.contenedorBusqueda :is(h6,h4)  {
    color: black;
}
.contenedorBusqueda section {
    display: inline-block; 
    box-sizing: border-box;
    width: 30%;
    margin: auto;
}

.estadoGrid{
    font-size: 1em;
    font-family: Arial, Helvetica, sans-serif;
    padding: 3px;
    border: solid 2px;
    border-radius: 2px;
}
.acceptadoGrid{   
    background-color: #abebc6;
    color: #239b56;   
}
.registradoGrid{
    color: #2874a6;
    background-color: #aed6f1;
}
.rechazadoGrid{
    color: #922b21;
    background-color: #d98880;
}
.imagen-nofound{
    width: 30%;
}
.convocatoria-noencontrada{
 width: 100%;
 height: 50%;
 text-align: center;
 color: #c90f08;
 font-size: 3em;
 margin-top: 3em;
 border-radius: 25% 10%;
}
    .caja-formulario{
        margin-left: 10em;
        margin-right: 10em;
        margin-bottom: 1.5em !important;
        display: block !important;
        color:black
    }
    .caja-principal{
         /* background-color: red;  */
        padding-left: 10em;
        padding-right: 10em;
        padding-bottom: 5em;

    }
    .caja-contenedora-formulario{
        /* background-color: blue; */
        border-color: black;
        padding-block: 2em;
        padding-bottom: 4em;
        border-radius: 25px;
        box-shadow: 0px 0px 30px rgb(188, 188, 189);
    }
    .campo{
        background-color: #e3e2e7;
    border: none;
    color:  #6c757d;
    text-transform: uppercase;
  

    }
    textarea.campo{
      height: 8em;
    }
    .asterisco-requerido{
        color: rgb(228, 3, 3);
    }
    .select-estilos{
        background-color: #e3e2e7;
        color: #6c757d;
    }
    .pestanas{
       
        margin-bottom: 4em;
        text-align: center;
        border:solid 1px #ced0d1;
        border-radius: 5px;
        padding: .5em;
        
    }
    .boton-pestana{
        width: 40%;
    }
    .botones-guardar{
        text-align: center;
    }
    .boton-general{
        width: 15em;
    }
    .mensaje-procesando{
        font-size: 5em;
    }
    .correo-valido{
        border:solid 1px #05c484;
    }
    .correo-invalido{
        border:solid 1px #c90f08;
    }

    .page-title {
    background-color: rgb(50,50,50);
    color: #FFF;
    padding: 2vh 20vw;
    text-align: center;
    border-top: solid white 15px;

  }

  @media (max-width: 600px) {
    .page-title{
      font-size: 2em;
    }

    h2{
      font-size: 1.8em;
    }
  }



</style>
<style>
    #fecha-nacimiento-convocatoriaweb{
    color:  #6c757d;
    font-size: 1.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/Convocatoria/EdicionDeFormularioPorAspirante.vue